/**
 * Stable CSS class names for E2E — Menu management (all).
 */
export const MMA = {
    page: 'menu-management-all-page',
    titleSection: 'menu-management-all-page__title-section',
    pageTitle: 'menu-management-all-page__title',
    actionsSection: 'menu-management-all-page__actions-section',
    inputButtonAddMenuApp: 'menu-management-all-page-input--button-add-menu-app',
    filterSection: 'menu-management-all-page__filter-section',
    inputTextFilter: 'menu-management-all-page-input--text-filter',
    gridSection: 'menu-management-all-page__grid-section',
    gridWrap: 'menu-management-all-page__grid-wrap',

    datagridEditCell: 'menu-management-all-datagrid-actions-cell-edit',
    inputButtonRowEdit: 'menu-management-all-datagrid-input--button-row-edit',
    datagridDeleteCell: 'menu-management-all-datagrid-actions-cell-delete',
    inputButtonRowDelete: 'menu-management-all-datagrid-input--button-row-delete',
} as const;

export const mmaCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
